var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0982 49.5521L32.8073 50.2585L33.515 49.5507L59.1634 23.9024L63.3902 28.1591L32.8059 58.7434L18.2242 44.1616L22.4473 39.9385L32.0982 49.5521ZM1.80877 40.1616C1.80877 18.6355 19.2798 1.16448 40.8059 1.16448C62.332 1.16448 79.8031 18.6355 79.8031 40.1616C79.8031 61.6878 62.332 79.1588 40.8059 79.1588C19.2798 79.1588 1.80877 61.6878 1.80877 40.1616ZM7.80305 40.1616C7.80305 58.3555 22.612 73.1645 40.8059 73.1645C58.9998 73.1645 73.8088 58.3555 73.8088 40.1616C73.8088 21.9678 58.9998 7.15876 40.8059 7.15876C22.612 7.15876 7.80305 21.9678 7.80305 40.1616Z",
    fill: "#7CB573",
    stroke: "white",
    strokeWidth: 2.00571
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.c115a4a4ab0fd823998f089961a8a3a4.svg";
export { ForwardRef as ReactComponent };